export default __webpack_public_path__ + "static/media/menu_active.c54cda1c.png";